// initial state
const state = {
  version: null,
  currentPage: null,
  miniDrawer: false,
  windowSize: {
    x: null,
    y: null
  },
  scrollPosition: {
    x: 0,
    y: 0
  },
  appDtls: {
    toolbarWidth: null,
    toolbarHeight: null,
  },
}

// getters
const getters = {
  version: (state, getters, rootState) => {
    return state.version;
  },
  currentPage: (state, getters, rootState) => {
    return state.currentPage;
  },
  miniDrawer: (state, getters, rootState) => {
    return state.miniDrawer;
  },
  windowSize: (state, getters, rootState) => {
    return state.windowSize;
  },
  scrollPosition: (state, getters, rootState) => {
    return state.scrollPosition;
  },
  appDtls: (state, getters, rootState) => {
    return state.appDtls;
  },
}

// actions
const actions = {
  setVersion({
    state,
    commit,
  }, payload) {
    commit('setVersion', {
      version: payload.version
    });
  },
  setCurrentPage({
    state,
    commit,
  }, payload) {
    commit('setCurrentPage', {
      currentPage: payload.currentPage
    });
  },
  setMiniDrawer({
    state,
    commit,
  }, payload) {
    commit('setMiniDrawer', {
      miniDrawer: payload.miniDrawer
    });
  },
  setWindowSize({
    state,
    commit,
  }, payload) {
    commit('setWindowSize', {
      windowSize: payload.windowSize
    });
  },
  setScrollPosition({
    state,
    commit,
  }, payload) {
    commit('setScrollPosition', {
      scrollPosition: payload.scrollPosition
    });
  },
  setAppDtls({
    state,
    commit,
  }, payload) {
    commit('setAppDtls', {
      appDtls: payload.appDtls
    });
  },
}

// mutations
const mutations = {
  setVersion(state, {
    version
  }) {
    state.version = version;
  },
  setCurrentPage(state, {
    currentPage
  }) {
    state.currentPage = currentPage;
  },
  setMiniDrawer(state, {
    miniDrawer
  }) {
    state.miniDrawer = miniDrawer;
  },
  setWindowSize(state, {
    windowSize
  }) {
    state.windowSize = windowSize;
  },
  setScrollPosition(state, {
    scrollPosition
  }) {
    state.scrollPosition = scrollPosition;
  },
  setAppDtls(state, {
    appDtls
  }) {
    state.appDtls = appDtls;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
